export const TotalizarByProp = (miArray, prop) => {
  var total = 0;
  miArray.forEach((item) => {
    total += Number(item[prop]);
  });
  return total;
};
